import { Avatar } from "@mui/material";

import { Tooltip } from "@mui/material";
import StyledIconButton from "./StyledIconButton";

interface SocialShareButtonProps {
  title: string;
  url: string;
  icon: React.ReactNode;
  onClick?: () => void;
}

const SocialShareButton = ({
  title,
  url,
  icon,
  onClick,
}: SocialShareButtonProps) => {
  return (
    <Tooltip title={title}>
      <Avatar
        sx={{
          height: 56,
          width: 56,
        }}
      >
        <StyledIconButton
          aria-label="Share on Twitter"
          onClick={
            onClick || (() => window.open(url, "_blank", "noopener,noreferrer"))
          }
        >
          {icon}
        </StyledIconButton>
      </Avatar>
    </Tooltip>
  );
};

export default SocialShareButton;
